import { MenuExpertsIcon } from 'assets/images/icons';
import { utilFormatDate } from 'common/utils';
import { AiVariantComment } from 'modules/mel-ai/types';

import styles from './context-history.module.scss';

interface ContextHistoryProps {
  contextHistory: AiVariantComment[];
}

const ContextHistory = ({ contextHistory }: ContextHistoryProps) => {
  return (
    <div className={styles.container}>
      {contextHistory.map((item) => (
        <div key={item.id} className={styles.commentContainer}>
          <MenuExpertsIcon />
          <div className={styles.commentRecord}>
            {utilFormatDate(item.created_at, { formatStr: 'dd/mm/yyyy - h:mm' })}
            <div className={styles.comment}>{item.comment}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export { ContextHistory };
